// GA4 client-ID fallback from first-party cookies (#1458). Session IDs are
// obtained through the Google tag API, never by parsing session cookies.
// Read only when statistics consent is granted.

export function readCookie(cookie: string, name: string): string[] {
  const values: string[] = [];
  for (const part of cookie.split(';')) {
    const separator = part.indexOf('=');
    if (separator < 0) {
      continue;
    }
    if (part.slice(0, separator).trim() === name) {
      values.push(part.slice(separator + 1).trim());
    }
  }
  return values;
}

const GA_COOKIE_RE = /^GA\d\.(\d+)\.(\d{1,20}\.\d{1,20})$/;

/**
 * Returns the client id from `_ga` (`GA1.<depth>.<random>.<timestamp>`). With a
 * configured cookie domain only the cookie written for that domain counts, so a
 * qa page never picks up the prod cookie set on `.reed.ai`.
 */
export function readClientId(cookie: string, cookieDomain?: string): string | undefined {
  const depth = cookieDomain ? cookieDomain.split('.').filter(Boolean).length : undefined;

  for (const value of readCookie(cookie, '_ga')) {
    const match = GA_COOKIE_RE.exec(value);
    if (match && (depth === undefined || Number(match[1]) === depth)) {
      return match[2];
    }
  }
  return undefined;
}
